module.exports = __webpack_public_path__ + "static/img/banner001.c500061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner001.png
// module id = +RuN
// module chunks = 15